export interface JSONCensus {
    cancelledAt?: string;
    createdAt: string;
    guid: string;
    periodEnd?: string;
    periodStart?: string;
    status: string;
    step: string;
    username: string;
}


export enum CENSUS_STATUS {
    CREATED = "CREATED",
    EQUIPMENT_SELECTED = "EQUIPMENT_SELECTED",
    SUBMITTED = "SUBMITTED",
    EXECUTED = "EXECUTED",
    FAILED = "FAILED",
}

export enum CENSUS_STEP {
    EQUIPMENT_SELECTION = "EQUIPMENT_SELECTION",
    PROCESSING = "PROCESSING",
    ACTIONS_REVIEW = "ACTIONS_REVIEW",
    ACTIONS_EXECUTION = "ACTIONS_EXECUTION",
    SUMMARY = "SUMMARY",
}